import { Testimony } from "../atoms/Testimony";

export const Testimonies = ({ testimonies = [], variant = "default" }) => {
    return (
        <div className="relative overflow-x-auto w-screen md:w-full
        -ml-5 md:m-auto px-5 flex gap-4 pb-16 !-mb-16 h-fit shrink-0">
            {testimonies.map((testimony) => (
                <Testimony
                    key={testimony.id}
                    variant={variant}
                    {...testimony}
                />
            ))}
        </div>
    );
};
